import React from "react";
import {useSearch} from "@okapi/router-react";
import {copyWithout} from "../../utils/copy-without";

// TODO: убрать этот хардкод
export const ArticlesType = () => {

    const [search, setSearch] = useSearch();
    const { type } = search
    const isAL = 'article-type-link-active';
    const isAT = 'article-type-active';

    return (
        <ul className="articles-type-ul">
            <li className="article-type-li">
                <div className={`articles-type__active ${type === 'how-to-choose' ? isAT : ''}`}/>
                <span onClick={() => setSearch({...search, type: 'how-to-choose'})}
                      className={`article-type-link ${type === 'how-to-choose' ? isAL : ''}`}>
                      Как выбрать
                </span>
            </li>
            <li className="article-type-li">
                <div className={`articles-type__active ${type === 'how-to-look' ? isAT : ''}`}/>
                <span onClick={() => setSearch({...search, type: 'how-to-look'})}
                      className={`article-type-link ${type === 'how-to-look' ? isAL : ''}`}>
                      Как ухаживать
                </span>
            </li>
            <li className="article-type-li">
                <div className={`articles-type__active ${type === 'how-to-make' ? isAT : ''}`}/>
                <span onClick={() => setSearch({...search, type: 'how-to-make'})}
                      className={`article-type-link ${type === 'how-to-make' ? isAL : ''}`}>
                      Как сделать
                </span>
            </li>
            <li className="article-type-li">
                <div className={`articles-type__active ${type === 'how-to-use' ? isAT : ''}`}/>
                <span onClick={() => setSearch({...search, type: 'how-to-use'})}
                      className={`article-type-link ${type === 'how-to-use' ? isAL : ''}`}>
                      Как использовать
                </span>
            </li>
            <li className="article-type-li">
                <div className={`articles-type__active ${type === 'be-inspired' ? isAT : ''}`}/>
                <span onClick={() => setSearch({...search, type: 'be-inspired'})}
                      className={`article-type-link ${type === 'be-inspired' ? isAL : ''}`}>
                      Вдохновиться
                </span>
            </li>
            <li className="article-type-li">
                <div className={`articles-type__active ${type ? '' : isAT}`}></div>
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
                {/* @ts-ignore */}
                <span onClick={() => setSearch(copyWithout(search, 'type'))}
                      className={`article-type-link ${type ? '' : isAL}`}>
                      Все типы
                </span>
            </li>
        </ul>
    )
}